/* eslint-disable camelcase */
import { getBackVersion } from '../config';
import api from './api';

export type DecryptionResponse = {
    value: string;
    expiresInSecs: number;
};

const encrypt = (
    valueToEncrypt: string,
    expiresInSeconds: number
): Promise<string> =>
    api.request<string>({
        method: 'POST',
        url: `${getBackVersion()}/encryption/encrypt`,
        data: {
            value: valueToEncrypt,
            expires_in_secs: expiresInSeconds,
        },
    });

const decrypt = (encryptedValue: string): Promise<DecryptionResponse> =>
    api.request<DecryptionResponse>({
        method: 'POST',
        url: `${getBackVersion()}/encryption/decrypt`,
        data: {
            value: encryptedValue,
        },
    });

type AsymmetricKey = {
    publicKey: string;
    id: number;
};

const requestAsymmetricKey = (
    entity: 'billing_summary' | 'workspace',
    entityId?: string
): Promise<AsymmetricKey> =>
    api.request<AsymmetricKey>({
        method: 'POST',
        url: `${getBackVersion()}/encryption/asymmetric_key`,
        data: {
            entity,
            entity_id: entityId,
        },
    });

export default {
    encrypt,
    decrypt,
    requestAsymmetricKey,
};
